module.exports = __webpack_public_path__ + "img/78.9d05a508.png";